
import Navbar from "@/components/Navbar";
import Footer from "@/components/sections/Footer";
import { MembershipForm } from "@/components/membership/MembershipForm";
import { MembershipInfo } from "@/components/membership/MembershipInfo";

const Membership = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow bg-gradient-to-b from-muted to-white">
        <div className="container mx-auto px-2 sm:px-4 pt-32 pb-16">
          <div className="max-w-[1400px] mx-auto">
            <h1 className="text-4xl font-bold text-center mb-2 text-primary">SPO Application for Membership</h1>
            <p className="text-muted-foreground text-center mb-8">
              Complete the form below to join SPO
            </p>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8 mb-12">
              <div className="space-y-6">
                <MembershipInfo />
              </div>

              <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
                <MembershipForm />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Membership;
